module.exports = __webpack_public_path__ + "static/media/poster311.42b80a62.png";